import { memo } from 'react';

import IndicatorChart from 'components/IndicatorChart/IndicatorChart';
import { FormatProperties } from 'models/response/modelOutput.interface';

export interface InputPanelChartV1Properties {
  chartLabelData: { [x: string]: number };
  chartData: Record<string, Record<string, number>> | [];
  chartType: string;
  formatProperties: FormatProperties;
  showLabel?: boolean;
  dimId?: number | string;
}

/** Input panel chart with black axis labels on white background (Figma 75644:16399). */
const InputPanelChartV1 = memo((properties: InputPanelChartV1Properties) => (
  <IndicatorChart {...properties} axisTheme='light' />
));

InputPanelChartV1.displayName = 'InputPanelChartV1';

export default InputPanelChartV1;
